import React__default, { createContext, useContext, useState } from 'react';
import Dialog from './Dialog.js';
import Typography from '../Atoms/Typography.js';
import Button from '../Atoms/Button.js';
import { useTranslation } from 'react-i18next';
import Portal from '../Atoms/Portal.js';
import classNames from './../external_lib/classnames/index.js';

var ConfirmContext = createContext(null);
function ConfirmProvider(_a) {
    var children = _a.children;
    var t = useTranslation().t;
    var _b = React__default.useState(false), _isOpen = _b[0], setIsOpen = _b[1];
    var _c = useState({}), props = _c[0], setProps = _c[1];
    var setData = function (confirmProps) {
        setProps(confirmProps);
    };
    var showDialog = function () {
        setIsOpen(true);
    };
    return (React__default.createElement(ConfirmContext.Provider, { value: { setData: setData, showDialog: showDialog } },
        children,
        React__default.createElement(Portal, null,
            React__default.createElement(Dialog, { classes: "confirm_dialog dialog__type__".concat(props.type), isOpen: _isOpen, onClose: function () {
                    var _a;
                    setIsOpen(false);
                    (_a = props === null || props === void 0 ? void 0 : props.onClose) === null || _a === void 0 ? void 0 : _a.call(props);
                }, title: props.title, uniqueKey: "confirm-box", removeCloseIcon: props.removeCloseIcon, footer: React__default.createElement("div", { className: "confirm_dialog__footer" },
                    React__default.createElement(Button, { variant: "outline", size: props.buttonSize, type: "primary", onClick: function () {
                            setIsOpen(false);
                            props.onCancel && props.onCancel();
                        } }, props.dismissText || t('common.dismiss')),
                    !props.removeConfirmButton ? (React__default.createElement(Button, { classes: classNames('confirm_dialog__footer__confirm_button', {
                            confirm_dialog__footer__confirm_button__delete: (props === null || props === void 0 ? void 0 : props.variant) === 'delete'
                        }), variant: (props === null || props === void 0 ? void 0 : props.bothOutline) ? 'outline' : 'solid', size: props.buttonSize, onClick: function () {
                            setIsOpen(false);
                            props.onConfirm && props.onConfirm();
                        } }, props.confirmText || t('common.confirm'))) : null) }, React__default.isValidElement(props.content) ? (props.content) : (React__default.createElement(Typography, { variant: "bodyTextOne", classes: "confirm_dialog__content" }, props.content))))));
}
function useConfirm() {
    var confirmation = useContext(ConfirmContext);
    return function (_a) {
        var title = _a.title, content = _a.content, type = _a.type, onConfirm = _a.onConfirm, onCancel = _a.onCancel, dismissText = _a.dismissText, confirmText = _a.confirmText, _b = _a.buttonSize, buttonSize = _b === void 0 ? 'md' : _b, variant = _a.variant, _c = _a.removeCloseIcon, removeCloseIcon = _c === void 0 ? true : _c, bothOutline = _a.bothOutline, _d = _a.removeConfirmButton, removeConfirmButton = _d === void 0 ? false : _d;
        confirmation.setData({
            title: title,
            content: content,
            type: type,
            onConfirm: onConfirm,
            onCancel: onCancel,
            dismissText: dismissText,
            confirmText: confirmText,
            variant: variant,
            buttonSize: buttonSize,
            removeCloseIcon: removeCloseIcon,
            bothOutline: bothOutline,
            removeConfirmButton: removeConfirmButton
        });
        confirmation.showDialog();
    };
}

export { ConfirmProvider, useConfirm as default };
//# sourceMappingURL=Confirm.js.map
